<p-floatLabel>
    <p-select #answerGroupStateDropdown
        id="answerGroupStateDropdown"
        name="answerGroupStateDropdown"
        [options]="answerGroupStates" 
        [(ngModel)]="selectedAnswerGroupState"
        [showClear]="!isRequired"
        [checkmark]="true"
        styleClass="w-100"
        (onChange)="onSelected()">
        <ng-template let-option pTemplate="item">
            {{ option.label }}
        </ng-template>
    </p-select>
    <label for="answerGroupStateDropdown">
        <app-label-content [isRequired]="isRequired">
            {{ l('::State') }}
        </app-label-content>
    </label>
</p-floatLabel>